export const typeTreeCache = {};

export const clearTypeTreeCache = () => {
  Object.keys(typeTreeCache).forEach((k) => delete typeTreeCache[k]);
};
